import { render, staticRenderFns } from "./ResourcesRequestPage.vue?vue&type=template&id=b598a7c6&scoped=true&lang=pug"
import script from "./ResourcesRequestPage.vue?vue&type=script&lang=js"
export * from "./ResourcesRequestPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b598a7c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b598a7c6')) {
      api.createRecord('b598a7c6', component.options)
    } else {
      api.reload('b598a7c6', component.options)
    }
    module.hot.accept("./ResourcesRequestPage.vue?vue&type=template&id=b598a7c6&scoped=true&lang=pug", function () {
      api.rerender('b598a7c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/analytic-services/components/ResourcesRequestPage.vue"
export default component.exports